/**
 * Copyright (c) 2025 Répét Contributors
 * Licensed under the MIT License
 * See LICENSE file in the project root for full license text
 */

/**
 * Configuration API Backend
 */

// URL du backend selon l'environnement
export const API_BASE_URL = import.meta.env.VITE_API_URL || 
  (import.meta.env.MODE === 'development' 
    ? 'http://localhost:8080'
    : 'https://repet2dev.ecanasso.org')

// Préfixe pour les endpoints API
export const API_PREFIX = '/api'

// Durée avant expiration d'un token (en millisecondes)
export const TOKEN_EXPIRY_BUFFER = 5 * 60 * 1000 // 5 minutes avant expiration réelle

// Clés de stockage local
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'repet_access_token',
  REFRESH_TOKEN: 'repet_refresh_token',
  USER: 'repet_user',
} as const
